import React, { useState } from 'react';
import { Header } from '../components/layout/Header';
import { Sidebar } from '../components/layout/Sidebar';
import { LedgerTab } from '../components/history/LedgerTab';
import { OrdersTab } from '../components/history/OrdersTab';
import { TradesTab } from '../components/history/TradesTab';
import { PositionsTab } from '../components/history/PositionsTab';
import { Download } from 'lucide-react';
type TabType = 'ledger' | 'orders' | 'trades' | 'positions';
export function HistoryPage() {
  const [activeTab, setActiveTab] = useState<TabType>('ledger');
  const tabs: {
    id: TabType;
    label: string;
  }[] = [{
    id: 'ledger',
    label: 'Ledger'
  }, {
    id: 'orders',
    label: 'Orders'
  }, {
    id: 'trades',
    label: 'Trades'
  }, {
    id: 'positions',
    label: 'Positions'
  }];
  const handleExport = () => {
    console.log('Export data for tab:', activeTab);
    // Export logic will be implemented based on active tab
  };
  return <div className="flex h-screen bg-background-primary text-text-primary overflow-hidden font-sans" data-id="element-1843">
      <Sidebar data-id="element-1844" />

      <div className="flex-1 flex flex-col min-w-0" data-id="element-1845">
        <Header data-id="element-1846" />

        <main className="flex-1 overflow-y-auto" data-id="element-1847">
          {/* Page Header */}
          <div className="border-b border-border-subtle bg-background-secondary" data-id="element-1848">
            <div className="px-6 py-4" data-id="element-1849">
              <div className="flex items-center justify-between mb-4" data-id="element-1850">
                <h1 className="text-2xl font-heading text-text-primary" data-id="element-1851">
                  Account History
                </h1>
                <button onClick={handleExport} className="flex items-center gap-2 px-4 py-2 bg-brand-purple hover:bg-brand-purple-light text-white rounded-lg transition-colors text-sm font-medium" data-id="element-1852">
                  <Download size={16} data-id="element-1853" />
                  Export
                </button>
              </div>

              {/* Tabs */}
              <div className="flex items-center gap-1" data-id="element-1854">
                {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`px-4 py-2 text-sm font-ui rounded-lg transition-all ${activeTab === tab.id ? 'bg-background-elevated text-text-primary' : 'text-text-secondary hover:text-text-primary hover:bg-background-elevated/50'}`} data-id="element-1855">
                    {tab.label}
                  </button>)}
              </div>
            </div>
          </div>

          {/* Tab Content */}
          <div className="p-6" data-id="element-1856">
            {activeTab === 'ledger' && <LedgerTab data-id="element-1857" />}
            {activeTab === 'orders' && <OrdersTab data-id="element-1858" />}
            {activeTab === 'trades' && <TradesTab data-id="element-1859" />}
            {activeTab === 'positions' && <PositionsTab data-id="element-1860" />}
          </div>
        </main>
      </div>
    </div>;
}